export default __webpack_public_path__ + "static/media/purchaseGrn.92edcefc.svg";